const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path fill-rule="evenodd" d="M4.966 16.872A.75.75 0 0 0 5.614 18h12.772a.75.75 0 0 0 .648-1.128l-6.3-10.78a.85.85 0 0 0-1.468 0zm.648 2.628c-1.737 0-2.82-1.885-1.943-3.385l6.3-10.78c.907-1.552 3.15-1.552 4.058 0l6.3 10.78c.876 1.5-.206 3.385-1.943 3.385z" clip-rule="evenodd"/></svg>';
export {
  e as w
};
